const DEFAULT_DELAY_MINUTES = 0
const MAX_DELAY_MINUTES = 60

/**
 * @typedef {Object} WebhookRuleDelay
 * @property {number} delay_minutes
 */

function normalizeDelayMinutes(value) {
  if (value === null || value === undefined || value === '') return DEFAULT_DELAY_MINUTES
  return Number(value)
}

function validateDelayMinutes(value) {
  if (value === '' || value === null || value === undefined) {
    return 'Укажите задержку от 0 до 60 минут'
  }
  const delay = Number(value)
  if (!Number.isInteger(delay) || delay < DEFAULT_DELAY_MINUTES || delay > MAX_DELAY_MINUTES) {
    return `Введите целое число от ${DEFAULT_DELAY_MINUTES} до ${MAX_DELAY_MINUTES}`
  }
  return ''
}

function delayMinutesPayload(value) {
  return {
    delay_minutes: normalizeDelayMinutes(value),
  }
}

function formatDelayMinutes(value) {
  const delay = normalizeDelayMinutes(value)
  return Number.isInteger(delay) && delay > 0 ? `Через ${delay} мин` : 'Без задержки'
}

module.exports = {
  DEFAULT_DELAY_MINUTES,
  delayMinutesPayload,
  formatDelayMinutes,
  normalizeDelayMinutes,
  validateDelayMinutes,
}
